import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers';
import axios from 'axios';
import { useAuth } from '../../auth';
import { useAppSelector } from '../../../../redux/hooks';
import { ViewModalNewCTX } from './componentsTable/ModalNew';
const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

type recordCTXNew={
    id:number,
    status:string,
    UserfirstName:string,
    UserlastName:string,
    TenantName:string,
    TenantDomain:string,
    cloud:string,
    type:string,
    Throughput:string,
    createdAt:string
}

function NewsCTXList() {
    const{currentUser}= useAuth()

    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)
    const tenant= useAppSelector(state =>state.TenantSlice.id)


    /*************************** CONSTANTES ***************************************/

    //const [Tickets,setTickets]=useState([])
    const [records,setRecords]= useState <recordCTXNew[]>([])

    /**********************Llamada a axios y parse de data**********************/
    useEffect( () => {
        if (currentUser?.ListPermiso?.includes('Support.List')){
        if (tenant===0){
            axios.get(API_URL+'/v1/newctx')
            .then(res=>{
                setRecords(res.data)
            })
        }
        else{
            axios.get(API_URL+'/v1/newctx/?tenantId='+tenant)
            .then(res=>{
                setRecords(res.data)
            })
        }
        }
     }, [tenant])

       

     /***********************************************************************************/
    return(
        <>
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='card-label fw-bold fs-3 mb-1'>CTX Request</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Here you will find are your created tickets</span>
            </h3>
            {/*Se agrega Boton para agregar usuarios*/}
           {/*<Link style={{marginRight:'15px'}}to="/create" className='btn btn-primary'>Add Nex User</Link>*/}
        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>

                {/* begin::Table */}
                    <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                        {/* begin::Table head */}
                        <thead>
                            {/*<tr className='border-0'>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'></th>
                                {columns.map((c:any,i:any)=>(
                                    <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center' key={i}>{c}</th>
                                ))}
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'>Action</th>
                                </tr>*/}
                            <tr className='border-0'>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'></th>
                                <th className='p-4 min-w-20px text-dark fw-bold mb-1 fs-5 text-center'>Request Number</th>
                                <th className='p-4 min-w-20px text-dark fw-bold mb-1 fs-5 text-center'>Created by</th>
                                <th className='p-4 min-w-20px text-dark fw-bold mb-1 fs-5 text-center'>Created at</th>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'>Tenant</th>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'>Cloud</th>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'>CTX Type/Throughput</th>
                                <th className='p-4 min-w-50px text-dark fw-bold mb-1 fs-5 text-center'>Details</th>
                            </tr>
                        </thead>
                        {/* end::Table head */}


                        {/* begin::Table body */}
                       <tbody>
                            {
                                records?.map((d,i)=>(
                                    <tr key={i}>
                                        <td id='id' className='text-center'>
                                            <div className='symbol symbol-45px me-2'>
                                            <span className='symbol-label'>
                                            <KTIcon iconName='bi bi-receipt-cutoff' className='text-info fs-1' />
                                            </span>
                                            </div>
                                        </td>
                                        <td  className='text-center'>{d.id}</td>
                                        <td  className='text-center'>{d.UserfirstName}  {d.UserlastName}</td>
                                        <td  className='text-center'>{d.createdAt.split('-')[0]+'-'+d.createdAt.split('-')[1]+'-'+d.createdAt.split('-')[2]}</td>
                                        <td  className='text-center'>{d.TenantName}</td>
                                        <td  className='text-center'>{d.cloud}</td>
                                        <td  className='text-center'>{d.type} / {d.Throughput}</td>
                                       {d.id !==0 && <td className='text-dark fw-semibold text-center'>
                                            <button onClick={ () => setID(d.id)} className='btn btn-primary'> See Details </button>
                                        </td>}
                                    </tr>
                                ))
                            }

                        </tbody>
                          {/* end::Table body */}

                    </table>
                     {/* end::Table */}
                </div>
               

            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        {/* end::Body */}
        </div>
      {  ID !== undefined && <ViewModalNewCTX setID={setID} id={ID} />}
        </>

	)
    }

export default NewsCTXList